document.addEventListener('DOMContentLoaded', function() {
 /* Insert custom Javascript here */
 
 // Initialize PDF size guide modal
 if (typeof theme !== 'undefined' && theme.Modals) {
   new theme.Modals('SizeGuideModal', 'size-guide');
   
   // Disable scroll when SizeGuideModal opens
   document.addEventListener('modalOpen.SizeGuideModal', function() {
     // Store current scroll position
     var scrollY = window.scrollY || window.pageYOffset;
     document.body.style.position = 'fixed';
     document.body.style.top = '-' + scrollY + 'px';
     document.body.style.width = '100%';
     document.body.style.overflow = 'hidden';
   });
   
   // Re-enable scroll when SizeGuideModal closes
   document.addEventListener('modalClose.SizeGuideModal', function() {
     // Restore scroll position
     var scrollY = document.body.style.top;
     document.body.style.position = '';
     document.body.style.top = '';
     document.body.style.width = '';
     document.body.style.overflow = '';
     if (scrollY) {
       window.scrollTo(0, parseInt(scrollY || '0') * -1);
     }
   });
 }
});
